<script setup lang="ts">
import { useAuthenticationStore } from '@/stores/authenticationStore';
import { useSystemStore } from '@/stores/systemStore';
import SimpleLayoutPrototypeWarning from './SimpleLayoutPrototypeWarning.vue';

const systemStore = useSystemStore();
const authenticationStore = useAuthenticationStore();
</script>

<template>
  <v-theme-provider theme="ptwLightTheme">
    <div class="outer-container">
      <div class="container v-theme--ptwLightTheme">
        <header>
          <h1 class="logo mb-6">{{ $t('Unicheck') }}</h1>
          <p v-if="systemStore.siteName" class="text-body-1 font-weight-semibold mb-2">
            {{ systemStore.siteName }}
          </p>
          <p class="text-body-2">
            IPIN {{ authenticationStore?.session?.ipin }} | {{ $t('Version') }}
            {{ systemStore.version }}
          </p>
        </header>
        <main class="pt-10">
          <slot />
          <SimpleLayoutPrototypeWarning v-if="systemStore.isPrototype" class="mt-10 text-left" />
        </main>
      </div>
    </div>
  </v-theme-provider>
</template>

<style lang="scss" scoped>
@use '@/styles/variables';

.outer-container {
  height: 100vh;
  overflow-y: auto;
}

.container {
  padding-top: 60px;
  text-align: center;
  margin: 0 auto;
  max-width: 800px;
  min-width: 500px;
  color: rgb(var(--v-theme-on-surface));
}

.logo {
  font-size: 60px;
  text-transform: uppercase;
}
</style>
